import moment from 'moment'

/**
 * `Mar 21 2025 @ 10:00AM`. The ' @ ' separator and the uppercase meridiem are both from the
 * design; everywhere else in the app formats times as `h:mma`.
 *
 * The backend sends `yyyy-MM-ddTHH:mm:ss.fffzzz` (DateTimeFormatHelper), so the offset is on the
 * wire and `.local()` is a real conversion, not a no-op.
 */
export function formatAlertDateTime(dateTime?: string | null): string {
  if (!dateTime) return '--'
  return moment(dateTime).local().format('MMM DD YYYY @ h:mmA')
}
